export default __webpack_public_path__ + "static/media/decorative-image-1.dc8da61a.jpg";